/**
 * Flushes first-touch acquisition attribution from sessionStorage to the API
 * after the user is authenticated (PBI #1104).
 */

import apiClient from './apiClient';
import { persistAcquisitionAttributionIfPresent } from './acquisitionAttributionService';

/**
 * Best-effort POST of stored attribution. Swallows errors so auth init is never blocked.
 */
export const flushAcquisitionAttributionToServer = async (): Promise<void> => {
  try {
    await persistAcquisitionAttributionIfPresent(async (path, body) => {
      await apiClient.post(path, body);
    });
  } catch (error) {
    console.warn('Failed to persist acquisition attribution; will retry on next auth sync', error);
  }
};
